var map = {
	"./de/cv-pause.png": "MiOf",
	"./en/cv-pause.png": "bw4G",
	"./es/cv-pause.png": "CdTJ",
	"./fr/cv-pause.png": "qc9N",
	"./ja/cv-pause.png": "RX/4",
	"./ko/cv-pause.png": "hKnV",
	"./pt/cv-pause.png": "gOSs",
	"./ru/cv-pause.png": "Prk4",
	"./tc/cv-pause.png": "JNWu",
	"./th/cv-pause.png": "MG6E"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7YY5";